// React
import React from "react";
import { Link } from 'react-router-dom';

// Utils
import { GoogleAnalytics } from '../../Utils';

// Component
import { Subscription } from './';

// Libraries
import ScrollableAnchor from 'react-scrollable-anchor';

import '../../Views/Login/login.css';
import './footer.css';

const Footer = () => {

    return (
        <ScrollableAnchor id={'footer'}>
            <React.Fragment>
            <footer>

                <div className='social-row'>

                    <div className='social-box'>
                        <div>
                            <Subscription />
                        </div>
                    </div>

                    <div className='social-box'>
                        <div>
                            <a href="https://join.slack.com/t/yety-community/shared_invite/enQtMzQ0NDAxNzE2MDE2LWI3ZGU4OTA0ZDU2ZTQxOTM3NDExMzgxNDNjODhkMjFjYzQ2ZDlmNTRjNDg4ZDZhOTY5ZjM0M2M4OWVlZjNhZmE" className='social-details'>
                                <div className='image-holder'>
                                    <img src="./assets/img/logo.svg" className='social-logo logo-yety' alt='Yety Slack Community'/>
                                    <div className='plus'>+</div>
                                    <img src="./assets/img/social/slack.png" className='social-logo' alt='Yety Slack Community'/>
                                </div>
                                <div className='social-writing'>Join our <b>Slack Community</b></div>
                            </a>
                        </div>
                    </div>

                </div>

                <div className='social-row'>

                    <div className='social-box'>
                        <div>
                            <a href="https://github.com/yety-app" className='social-details'>
                                <div className='image-holder'>
                                    <img src="./assets/img/social/github.png" className='social-logo' alt='Yety Github'/>
                                </div>
                                <div className='social-writing'>github.com/<b>yety-app</b></div>
                            </a>
                        </div>
                    </div>

                    <div className='social-box'>
                        <div>
                            <a href="https://twitter.com/yety_app" className='social-details'>
                                <div className='image-holder'>
                                    <img src="./assets/img/social/twitter.png" className='social-logo' alt='Yety Twitter Page'/>
                                </div>
                                <div className='social-writing'>twitter.com/<b>yety_app</b></div>
                            </a>
                        </div>
                    </div>

                </div>

            </footer>   

            <div className='post-footer'>

                <div className='wrapper'>

                    <div className='logo-codename'>
                        <div className='footer-logo'>
                            <img src="./assets/img/logo.svg" alt='Yety Logo'/>
                            <div>yety</div>
                        </div>
                        <div>
                            annapurna II
                        </div>
                    </div>

                    <div className='site-links'>
                        <Link to="/dashboard" onClick={() => GoogleAnalytics.newAction('Footer','Dashboard')}>Dashboard</Link>
                        <Link to="/markets" onClick={() => GoogleAnalytics.newAction('Footer','Markets')}>Markets</Link>
                        <Link to="/charts" onClick={() => GoogleAnalytics.newAction('Footer','Charts')}>Charts</Link>
                        <Link to="/our-story" onClick={() => GoogleAnalytics.newAction('Footer','Our Story')}>Our Story</Link>
                        <Link to="/comingsoon" onClick={() => GoogleAnalytics.newAction('Footer','Roadmap')}>Roadmap</Link>
                        <Link to="/comingsoon" onClick={() => GoogleAnalytics.newAction('Footer','Privacy Policy')}>Privacy Policy</Link>
                    </div>

                    <div className='copyright'>
                        <div>
                            <a href='mailto:accounts@yety.io' className='email'>
                                <i className="icon-paperplane text-size-xlarge"></i>
                                Contact Us
                            </a>
                        </div>
                        <div className='company'>Copyright © 2018 Yety Analytics, Inc. All rights reserved.</div>
                    </div>

                </div>
            </div>

            </React.Fragment>
        </ScrollableAnchor>
    );

};

export default Footer;


// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js